"use client"

import type React from "react"
import { useMobile } from "../hooks/useMobile"

import { useState, useRef, useEffect } from "react"
import {
  useSubscription,
  useMutation,
  useQuery
} from '@apollo/client';
import { gql } from "@apollo/client"
import { getToken } from "../hooks/AuthProvider";
import ProfilePicTemp from "../ProfilePicTemp.png"
import axios from "axios"
import { X } from "lucide-react"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//   faPaperPlane,
//   faXmark,
//   faFlag,
//   faHeart,
//   faThumbsUp,
//   faGift,
//   faFaceSmile,
//   faGear,
//   faEllipsisH,
//   faArrowUpRightFromSquare,
//   faMoon,
//   faSun,
//   faVolumeHigh,
//   faVolumeXmark,
//   faReply,
//   faPlus,
//   faChevronDown,
//   faChevronUp,
// } from "@fortawesome/free-solid-svg-icons"

export const LIVESTREAM_CHAT_SUBSCRIPTION = gql`
  subscription LivestreamChat($channelID: String!) {
    livestreamCHAT(channelID: $channelID) {
      commentID
      message
      createdAt
      hidden
      user {
        id
        username
        displayName
        avatar
        isModerator
        isCreator
      }
      replyTo {
        id
        user
        message
      }
    }
  }
`;

export const DELETE_MESSAGE_SUBSCRIPTION = gql`
  subscription DeleteMessage($channelID: String!) {
    DeleteMessage(channelID: $channelID) {
      commentID
      userID
      deleteAll
    }
  }
`

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($channelID: String!, $sender: String!, $msg: LivestreamChatInput!) {
    sendChatMessage(channelID: $channelID, sender: $sender, msg: $msg) {
      commentID
    }
  }
`;

export const DELETE_MESSAGE = gql`
  mutation DeleteChatMessage($channelID: String!, $token: String!, $commentID: String!) {
    deleteChatMessage(channelID: $channelID, token: $token, commentID: $commentID)
  }
`

// export const BAN_USER = gql`
//   mutation BanUser($channelID: String!, $token: String!, $commentID: String!) {
//     banUser(channelID: $channelID, token: $token, commentID: $commentID)
//   }
// `

export const BAN_USER = gql`
  mutation BanUser($channelID: String!, $token: String!, $userID: String!) {
    BanUser(channelID: $channelID, token: $token, userID: $userID)
  }
`

export const TIMEOUT_USER = gql`
  mutation TimeoutUser($channelID: String!, $token: String!, $userID: String!, $duration: Int!) {
    TimeoutUser(channelID: $channelID, token: $token, userID: $userID, duration: $duration)
  }
`

// export const TIMEOUT_USER = gql`
//   mutation TimeoutUser($channelID: String!, $token: String!, $commentID: String!) {
//     timeoutUser(channelID: $channelID, token: $token, commentID: $commentID)
//   }
// `

export const LIVESTREAM_PARTICIPANTS_SUBSCRIPTION = gql`
  subscription LivestreamParticipants($channelID: String!) {
    livestreamParticipants(channelID: $channelID) {
      userID
      channelID
      displayName
      profilePic
      ModStatus
      joinedAt
    }
  }
`;

export const GET_BAN_STATUS = gql`
  query GetBanStatus($token: String!, $creatorID: String!) {
    getBanStatus(token: $token, creatorID: $creatorID) {
      userID
      creatorID
      isBanned
      banReason
    }
  }
`

export const USER_BAN_STATUS_SUBSCRIPTION = gql`
  subscription UserBanStatus($creatorID: String!) {
    userBanStatus(creatorID: $creatorID) {
      userID
      creatorID
      isBanned
      banReason
    }
  }
`


// interface LivestreamChatInput {
//   id: string
//   message: string
//   timestamp: string
// }

interface ChatMessageInput {
  id: string
  message: string
  timestamp: string
  replyTo?: {
    id: string
    user: string
    message: string
  }
  reactions?: {
    type: string
    count: number
  }[]
}

interface DeleteMSG {
  commentID: string;
  userID: string;
  deleteAll: boolean;
}

interface liveMSG {
  commentID: string
  user: {
    id: string
    avatar: string
    displayName: string
    username?: string
    isCreator: boolean
    isModerator: boolean
  }
  message: string
  createdAt: string
  hidden: boolean
  replyTo?: {
    id: string
    user: string
    message: string
  }
  reactions?: {
    type: string
    count: number
  }[]
  deleted?: boolean; // Optional field to indicate if the message is deleted
}

interface Participant {
  userID: string;
  channelID: string;
  displayName: string;
  profilePic?: string;
  ModStatus: boolean;
  joinedAt: string;
}

interface LiveChatProps {
  onClose?: () => void
}

type ModerationAction = "ban" | "timeout" | null

export default function LiveChat({ onClose }: LiveChatProps) {
  const isMobile = useMobile();
  const [messages, setMessages] = useState<liveMSG[]>([])
  const [participants, setParticipants] = useState<Participant[]>([])

  const [newMessage, setNewMessage] = useState("")
  const [activeTab, setActiveTab] = useState("chat")
  const [showDropdown, setShowDropdown] = useState<string | null>(null)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [showReactionPicker, setShowReactionPicker] = useState<string | null>(null)
  const [showSettingsMenu, setShowSettingsMenu] = useState(false)
  const [isDarkMode, setIsDarkMode] = useState(true)
  const [isMuted, setIsMuted] = useState(false)
  const [replyingTo, setReplyingTo] = useState<{ id: string; user: string; message: string } | null>(null)
  const chatEndRef = useRef<HTMLDivElement>(null)
  const chatContainerRef = useRef<HTMLDivElement>(null)
  const [autoScroll, setAutoScroll] = useState(true)
  const inputRef = useRef<HTMLInputElement>(null)
  const mentionListRef = useRef<HTMLDivElement>(null)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [mentionQuery, setMentionQuery] = useState("")
  const [showMentionList, setShowMentionList] = useState(false)
  const [participantSearch, setParticipantSearch] = useState("")
  const [myDisplayName, setDisplayName] = useState<string | null>(null)
  const [modStatus, setModStatus] = useState<boolean>(false)
  const [banned, setBanned] = useState<boolean>(false)
  const [timeout, setTimedout] = useState<boolean>(false)
  const [sendMessage] = useMutation(SEND_CHAT_MESSAGE);
  const [removeMessage] = useMutation(DELETE_MESSAGE);
  const [duration, setDuration] = useState("")
  const [reason, setReason] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [reportModalOpen, setReportOpen] = useState(false);
  const [moderationAction, setModerationAction] = useState<ModerationAction>(null)
  const [connectionState, setConnectionState] = useState<'connecting' | 'connected' | 'disconnected'>('connecting');
  const [banUser] = useMutation(BAN_USER);
  const [timeoutUser] = useMutation(TIMEOUT_USER);
  const [targetUserID, setTargetUserID] = useState<string | null>(null)
  const [inputBanned, setUserBanned] = useState<boolean>(false)
  const [creatorUserID, setCreatorID] = useState<boolean>(false)
  const [mainLoading, setLoading] = useState<boolean>(true)

  const [dragStartY, setDragStartY] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const dragHandleRef = useRef<HTMLDivElement>(null)

  const handleScroll = () => {
    const container = chatContainerRef.current
    if (!container) return
    const atBottom =
      container.scrollHeight - container.scrollTop <= container.clientHeight + 1
    setAutoScroll(atBottom)
  }

  useEffect(() => {
    // chatEndRef.current?.scrollIntoView({ behavior: "smooth" })
    if (autoScroll) {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [messages, autoScroll])

  const channelID = window.location.href.split('/user')[1]?.split('/')[1];

  // const { data, loading } = useSubscription(LIVESTREAM_CHAT_SUBSCRIPTION, {
  //   variables: { channelID }
  // });

  const { data, loading, error } = useSubscription(LIVESTREAM_CHAT_SUBSCRIPTION, {
    variables: { channelID },
    onError: () => {
      setConnectionState('disconnected');
    },
  });

  useEffect(() => {
    const handleConnected = () => setConnectionState('connected');
    const handleDisconnected = () => setConnectionState('disconnected');

    window.addEventListener('livechat-ws-connected', handleConnected);
    window.addEventListener('livechat-ws-disconnected', handleDisconnected);

    return () => {
      window.removeEventListener('livechat-ws-connected', handleConnected);
      window.removeEventListener('livechat-ws-disconnected', handleDisconnected);
    };
  }, []);

  useEffect(() => {
    if (loading) {
      setConnectionState('connecting');
    }
  }, [loading]);

  useEffect(() => {
    if (error) {
      setConnectionState('disconnected');
    }
  }, [error]);

  const { data: deleteData } = useSubscription(DELETE_MESSAGE_SUBSCRIPTION, {
    variables: { channelID },
    onData: ({ data }) => {
      console.log("Delete message received:", data);
      // Remove the message from state
    },
  });

  const { data: participantData } = useSubscription(
    LIVESTREAM_PARTICIPANTS_SUBSCRIPTION,
    { variables: { channelID } }
  );

  const { data: banStatusData } = useQuery(GET_BAN_STATUS, {
    variables: { token: getToken() || '', creatorID: creatorUserID },
    skip: !creatorUserID || !getToken()
  });

  useSubscription(USER_BAN_STATUS_SUBSCRIPTION, {
    variables: { creatorID: creatorUserID },
    onData: ({ data }) => {
      console.log("User ban status data:", data);
      const status = data.data?.userBanStatus;
      if (status) {
        setUserBanned(status.isBanned);
      }
    }
  });

  useEffect(() => {
    if (banStatusData?.getBanStatus) {
      // console.log("Ban status data:", banStatusData.getBanStatus);
      setUserBanned(banStatusData.getBanStatus.isBanned);
    }
  }, [banStatusData]);

  useEffect(() => {
    const tok = getToken();
    if (!tok) return;
    try {
      // axios.get(`${process.env.REACT_APP_API_URL}api/v1/user`, { headers: { 'x-auth-token': tok } }).then((response) => {
      axios.get(`${process.env.REACT_APP_API_URL}api/v1/stream/${channelID}/details`, { headers: { 'x-auth-token': tok } }).then((response) => {
        // setDisplayName(response.data.user.displayName)
        setDisplayName(response.data.myDisplayName);
        setModStatus(response.data.mod);
        setBanned(response.data.isBanned);
        setTimedout(response.data.isTimedout);
      });

      axios.get(`${process.env.REACT_APP_API_URL}api/v1/live/${channelID}`, { headers: { 'x-auth-token': getToken() } }).then((response) => {
        setCreatorID(response.data.creatorID);
        setLoading(false);
      });
    } catch (err) {
      console.log("Error fetching chat messages:", err);
    }
  }, [])

  useEffect(() => {
    if (data?.livestreamCHAT) {
      console.log(data?.livestreamCHAT);
      setMessages((prev) => [...prev, data.livestreamCHAT]);
    }
  }, [data])

  // useEffect(() => {
  //   // console.log("Delete data:", deleteData);
  //   if (deleteData?.DeleteMessage) {
  //     console.log("Delete message received:", deleteData.DeleteMessage.commentID);
  //     const del = deleteData.DeleteMessage as DeleteMSG
  //     // setMessages(prev => prev.filter(m => m.commentID === del.commentID ? false : true))
  //     setMessages(prev => prev.filter(m => m.commentID !== del.commentID));
  //   }
  // }, [deleteData])

  // useEffect(() => {
  //   if (deleteData?.DeleteMessage) {
  //     console.log("Delete message received:", deleteData.DeleteMessage.commentID);
  //     const del = deleteData.DeleteMessage as DeleteMSG;
  
  //     setMessages(prev =>
  //       prev.map(m =>
  //         m.commentID === del.commentID
  //           ? {
  //               ...m,
  //               message: "*This message has been deleted*",
  //               deleted: true, // optional: flag it if needed in the UI
  //             }
  //           : m
  //       )
  //     );
  //   }
  // }, [deleteData]);

  useEffect(() => {
    if (deleteData?.DeleteMessage) {
      const del = deleteData.DeleteMessage as DeleteMSG;
      const deleteAll = del.deleteAll; // assuming deleteAll is passed in the subscription payload
  
      console.log("Delete message received:", del.commentID, "deleteAll:", deleteAll);
  
      setMessages(prev =>
        deleteAll
          ? prev.map(m => ({
              ...m,
              message: "*This message has been deleted*",
              deleted: true,
            }))
          : prev.map(m =>
              m.commentID === del.commentID
                ? {
                    ...m,
                    message: "*This message has been deleted*",
                    deleted: true,
                  }
                : m
            )
      );
    }
  }, [deleteData]);

  useEffect(() => {
    if (participantData?.livestreamParticipants) {
      setParticipants(participantData.livestreamParticipants);
    }
  }, [participantData])

  const filteredParticipants = participants.filter((p) =>
    p.displayName.toLowerCase().includes(participantSearch.toLowerCase())
  )

  const handleDragStart = (clientY: number) => {
    setDragStartY(clientY)
    setIsDragging(true)
  }

  const handleDragMove = (clientY: number) => {
    if (!isDragging) return

    const deltaY = dragStartY - clientY
    // If dragged up more than 50px, expand the chat
    if (deltaY > 50 && isCollapsed) {
      setIsCollapsed(false)
      setIsDragging(false)
    }
    // If dragged down more than 50px, collapse the chat
    else if (deltaY < -50 && !isCollapsed) {
      setIsCollapsed(true)
      setIsDragging(false)
    }
  }

  const handleDragEnd = () => {
    setIsDragging(false)
  }

  // const handleModerationClick = (action: ModerationAction) => {
  //   setModerationAction(action)
  //   setIsModalOpen(true)
  // }

  const handleModerationClick = (action: ModerationAction, userID: string) => {
    setModerationAction(action)
    setTargetUserID(userID)
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setDuration("")
    setReason("")
    setModerationAction(null)
    setTargetUserID(null)
  }

  const getDurationOptions = () => {
    if (moderationAction === "ban") {
      return [
        { value: "1d", label: "1 Day" },
        { value: "7d", label: "7 Days" },
        { value: "1m", label: "1 Month" },
        { value: "6m", label: "6 Months" },
        { value: "1y", label: "1 Year" },
        { value: "permanent", label: "Infinity" },
      ]
    } else {
      return [
        { value: "1h", label: "1 Hr" },
        { value: "6h", label: "6 Hr" },
        { value: "1d", label: "1 Day" },
        { value: "7d", label: "7 Days" },
        { value: "1m", label: "1 Month" },
        { value: "6m", label: "6 Months" },
      ]
    }
  }

  const parseDuration = (val: string) => {
    const map: Record<string, number> = {
      '1h': 60 * 60,
      '6h': 6 * 60 * 60,
      '1d': 24 * 60 * 60,
      '7d': 7 * 24 * 60 * 60,
      '1m': 30 * 24 * 60 * 60,
      '6m': 6 * 30 * 24 * 60 * 60,
      '1y': 365 * 24 * 60 * 60,
      permanent: -1,
    }
    return map[val] ?? 0
  }

  const handleConfirm = async () => {
    if (!targetUserID) return
    // Handle the moderation action here
    console.log(`${moderationAction} user for ${duration} - Reason: ${reason}`)

    // Implement post logic here.
    try {
      const token = getToken()
      if (!token) return

      if (moderationAction === 'ban') {
        await banUser({ variables: { channelID, token, userID: targetUserID } })
      } else if (moderationAction === 'timeout') {
        const dur = parseDuration(duration)
        await timeoutUser({ variables: { channelID, token, userID: targetUserID, duration: dur } })
      }
    } catch (err) {
      console.error('Moderation error', err)
    }

    // Reset form and close modal
    setIsModalOpen(false)
    setDuration("")
    setReason("")
    setModerationAction(null)
    setTargetUserID(null)
  }

  const confirmReport = () => {
    // Send info to server

    // Modify Reason to include the report MSG info, 
    var newReason = reason + `\n\nReported by: ${myDisplayName || "Unknown"}\nChannel ID: ${channelID}\nUser ID: ${getToken()}\nMessage ID: \nOriginal Message:`

    axios.post(`${process.env.REACT_APP_API_URL}api/v1/report/general`, { category: 'stream', desc: newReason, title: `Stream Report` }, { headers: { 'x-auth-token': getToken() }}).then((res) => {
      console.log("Report submitted:", res.data);
      alert("Report submitted successfully!");
    })

    setReportOpen(false);
    setReason("");
  }

  const closeReport = () => {
    setReportOpen(false);
    setReason("");
  }

  // Add event listeners for mouse/touch events on the document
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => handleDragMove(e.clientY)
    const handleTouchMove = (e: TouchEvent) => {
      if (e.touches.length > 0) {
        handleDragMove(e.touches[0].clientY)
      }
    }

    const handleMouseUp = () => handleDragEnd()
    const handleTouchEnd = () => handleDragEnd()

    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove)
      document.addEventListener("touchmove", handleTouchMove)
      document.addEventListener("mouseup", handleMouseUp)
      document.addEventListener("touchend", handleTouchEnd)
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove)
      document.removeEventListener("touchmove", handleTouchMove)
      document.removeEventListener("mouseup", handleMouseUp)
      document.removeEventListener("touchend", handleTouchEnd)
    }
  }, [isDragging, isCollapsed])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setNewMessage(value)

    const cursorPos = e.target.selectionStart || 0
    const textUpToCursor = value.slice(0, cursorPos)
    const match = textUpToCursor.match(/@([\w]*)$/)
    if (match) {
      const query = match[1]
      setMentionQuery(match[1])
      setShowMentionList(query.length > 0)
    } else {
      setShowMentionList(false)
      setMentionQuery("")
    }
  }

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (showMentionList && e.key === 'Tab') {
      e.preventDefault()
      const firstButton = mentionListRef.current?.querySelector('button') as HTMLButtonElement | null
      firstButton?.focus()
    }
  }

  const handleSendMessage = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!newMessage.trim()) return

    const message: ChatMessageInput = {
      id: Date.now().toString(),
      message: newMessage,
      timestamp: new Date().toISOString(),
      ...(replyingTo && { replyTo: replyingTo }),
    }

    await sendMessage({
      variables: {
        channelID: channelID, // Replace with actual channel ID
        sender: getToken(),
        msg: message
      },
    });

    // setMessages([...messages, message])
    setNewMessage("")
    setMentionQuery("")
    setShowMentionList(false)
    setReplyingTo(null)
  }

  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp)
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  }

  // const addReaction = (messageId: string, emojiType: string) => {
  //   setMessages(
  //     messages.map((msg) => {
  //       if (msg.id === messageId) {
  //         const reactions = msg.reactions || []
  //         const existingReaction = reactions.find((r) => r.type === emojiType)

  //         if (existingReaction) {
  //           return {
  //             ...msg,
  //             reactions: reactions.map((r) => (r.type === emojiType ? { ...r, count: r.count + 1 } : r)),
  //           }
  //         } else {
  //           return {
  //             ...msg,
  //             reactions: [...reactions, { type: emojiType, count: 1 }],
  //           }
  //         }
  //       }
  //       return msg
  //     }),
  //   )

  //   setShowReactionPicker(null)
  // }

  const toggleDropdown = (id: string) => {
    if (showDropdown === id) {
      setShowDropdown(null)
    } else {
      setShowDropdown(id)
    }
  }

  const handleReply = (message: liveMSG) => {
    setReplyingTo({
      id: message.commentID,
      user: message.user.displayName,
      message: message.message.length > 50 ? message.message.substring(0, 50) + "..." : message.message,
    })
    inputRef.current?.focus()
  }

  const cancelReply = () => {
    setReplyingTo(null)
  }

  const insertEmoji = (emojiChar: string) => {
    setNewMessage((prev) => prev + emojiChar)
    setShowEmojiPicker(false)
    inputRef.current?.focus()
  }

  const selectMention = (user: Participant) => {
    if (!inputRef.current) return
    const input = inputRef.current
    const start = input.selectionStart || 0
    const beforeCursor = newMessage.slice(0, start)
    const afterCursor = newMessage.slice(input.selectionEnd || start)
    const match = beforeCursor.match(/@([\w]*)$/)
    if (!match) return
    const beforeMention = beforeCursor.slice(0, match.index)
    const newText = `${beforeMention}@${user.displayName} ${afterCursor}`
    setNewMessage(newText)
    const caretPos = beforeMention.length + user.displayName.length + 2
    setTimeout(() => {
      input.focus()
      input.setSelectionRange(caretPos, caretPos)
    }, 0)
    setShowMentionList(false)
    setMentionQuery("")
  }

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker)
  }

  const toggleReactionPicker = (messageId: string | null) => {
    setShowReactionPicker(messageId)
    if (messageId === null) {
      setShowDropdown(null)
    }
  }

  const toggleSettingsMenu = () => {
    setShowSettingsMenu(!showSettingsMenu)
  }

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode)
  }

  const toggleMute = () => {
    setIsMuted(!isMuted)
  }

  const openPopoutChat = () => {
    // Open chat in a new window
    const width = 812
    const height = 600
    const left = window.screen.width - width
    const top = window.screen.height - height - 100
    window.open("./live/chat", "LiveChat", `width=${width},height=${height},left=${left},top=${top}`)
    setShowSettingsMenu(false)
  }

  // Get popular emojis
  const popularEmojis = [
    "😀",
    "😂",
    "❤️",
    "👍",
    "🔥",
    "🎮",
    "👏",
    "😍",
    "🤔",
    "😎",
    "🙌",
    "👀",
    "💯",
    "🤣",
    "😊",
    "🎉",
    "💪",
    "🙏",
    "👋",
    "😭",
  ]

  // Find a message by ID
  const findMessageById = (id: string) => {
    return messages.find((msg) => msg.commentID === id)
  }

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const highlightMentions = (text: string) => {
    if (!myDisplayName) return text
    const regex = new RegExp(`@${myDisplayName}\\b`, 'gi')
    const parts: React.ReactNode[] = []
    let lastIndex = 0
    let match: RegExpExecArray | null
    while ((match = regex.exec(text)) !== null) {
      parts.push(text.slice(lastIndex, match.index))
      parts.push(
        <span
          key={match.index}
          className="bg-red-600/20 text-red-400 px-1 rounded"
        >
          {match[0]}
        </span>
      )
      lastIndex = match.index + match[0].length
    }
    parts.push(text.slice(lastIndex))
    return parts
  }

  async function deleteMSG(commentID: string) {
    console.log(commentID, channelID)
    await removeMessage({
      variables: {
        channelID: channelID, // Replace with actual channel ID
        token: getToken(),
        commentID: commentID
      },
    });
  }

  return (
    <div
      className={`h-full flex flex-col bg-black/30 backdrop-blur-xl rounded-xl border border-white/5 overflow-hidden transition-opacity duration-300 opacity-100 ${isDarkMode ? "dark" : ""}`}
    >
      <h1 className="text-2xl font-bold px-4 pt-4">Live Chat
        {(() => {
          if (connectionState === 'disconnected') {
              return <span className="text-red-500"> - Disconnected</span>;
          } else if (connectionState === 'connecting') {
              return <span className="text-slate-500 animate-pulse"> - Connecting</span>;
          } else if (connectionState === 'connected') {
              return (
                  <span className="relative inline-flex mx-2 w-3 h-3 align-middle">
                      <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
                      <span className="relative inline-flex w-3 h-3 rounded-full bg-green-500"></span>
                  </span>
              );
          }
        })()}
      </h1>
      {onClose && (
        <div
          ref={dragHandleRef}
          className={`md:hidden p-2 border-b border-white/10 flex items-center justify-center cursor-grab ${
            isDragging ? "cursor-grabbing" : ""
          }`}
          onMouseDown={(e) => handleDragStart(e.clientY)}
          onTouchStart={(e) => {
            if (e.touches.length > 0) {
              handleDragStart(e.touches[0].clientY)
            }
          }}
        >
          <div className="w-10 h-1 bg-white/20 rounded-full"></div>
          <span className="sr-only">Drag to expand or collapse chat</span>
        </div>
      )}
      <div className="p-3 border-b border-white/10 flex items-center justify-between">
        <div className="w-full">
          <div className="flex items-center justify-between mb-4">
            <div className="bg-white/5 p-0.5 rounded-md">
              <div className="flex">
                <button
                  onClick={() => setActiveTab("chat")}
                  className={`px-3 py-1 rounded-sm transition-colors ${
                    activeTab === "chat" ? "bg-white/10 text-white" : "text-white/70 hover:text-white"
                  }`}
                >
                  Chat
                </button>
                <button
                  onClick={() => setActiveTab("participants")}
                  className={`px-3 py-1 rounded-sm transition-colors ${
                    activeTab === "participants" ? "bg-white/10 text-white" : "text-white/70 hover:text-white"
                  }`}
                >
                  Participants
                </button>
              </div>
            </div>

            <div className="flex items-center space-x-2">
                <a href="./live/modview"
                  // onClick={toggleSettingsMenu}
                  target="_blank"
                  className="h-8 w-8 text-white/70 hover:text-white hover:bg-white/10 rounded-full flex items-center justify-center transition-colors"
                >
                  {/* <FontAwesomeIcon icon={faGear} className="text-sm" /> */}
                  <i className="fas fa-shield text-sm"></i>
                </a>
              <div className="relative">
                <button
                  onClick={toggleSettingsMenu}
                  className="h-8 w-8 text-white/70 hover:text-white hover:bg-white/10 rounded-full flex items-center justify-center transition-colors"
                >
                  {/* <FontAwesomeIcon icon={faGear} className="text-sm" /> */}
                  <i className="fas fa-cog text-sm"></i>
                </button>

                {showSettingsMenu && (
                  <div className="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-[#1A1A24] border border-white/10 z-20">
                    <div className="py-1">
                      <button
                        onClick={openPopoutChat}
                        className="flex items-center w-full text-left px-4 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10"
                      >
                        {/* <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mr-2 text-xs" /> */}
                        <i className="fas fa-external-link-square-alt mr-2 text-xs"></i>
                        <span>Pop out chat</span>
                      </button>
                      {/* <button
                        onClick={toggleDarkMode}
                        className="flex items-center w-full text-left px-4 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10"
                      >
                        {isDarkMode ? (
                          <>
                            <i className="fas fa-sun mr-2 text-xs"></i>
                            <span>Light mode</span>
                          </>
                        ) : (
                          <>
                            <i className="fas fa-moon mr-2 text-xs"></i>
                            <span>Dark mode</span>
                          </>
                        )}
                      </button> */}
                      {/* <button
                        onClick={toggleMute}
                        className="flex items-center w-full text-left px-4 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10"
                      >
                        {isMuted ? (
                          <>
                            <i className="fas fa-volume-up mr-2 text-xs"></i>
                            <span>Unmute chat</span>
                          </>
                        ) : (
                          <>
                            <i className="fas fa-volume-mute mr-2 text-xs"></i>
                            <span>Mute chat</span>
                          </>
                        )}
                      </button> */}
                    </div>
                  </div>
                )}
              </div>

              {onClose && (
                <button
                  onClick={toggleCollapse}
                  className="h-8 w-8 text-white/70 hover:text-white hover:bg-white/10 rounded-full flex items-center justify-center transition-colors"
                >
                  {/* <FontAwesomeIcon icon={isCollapsed ? faChevronUp : faChevronDown} className="text-sm" /> */}
                  <i className={`fas fa-chevron-${isCollapsed ? "up" : "down"} text-sm`}></i>
                </button>
              )}
            </div>
          </div>

          {activeTab === "chat" ? (
            <>
              <div
                ref={chatContainerRef}
                onScroll={handleScroll}

                // className={`flex-grow overflow-y-auto p-4 space-y-4 max-h-[calc(100vh-600px)] md:min-h-[400px] ${
                className={`relative flex-grow overflow-y-auto p-4 space-y-4 max-h-[calc(100vh-600px)] md:min-h-[400px] ${
                  isCollapsed ? "min-h-0" : "min-h-[200px]"
                // } transition-all duration-300 ${isCollapsed && isMobile ? "h-0 p-0 opacity-0" : "opacity-100"}`}
                } transition-all duration-300 ${isCollapsed && isMobile ? "h-0 p-0 opacity-0" : "opacity-100" }`}
              >
                {messages.map((msg) => (
                  <div
                    key={msg.commentID}
                    // className="flex items-start group transition-opacity duration-200 opacity-100 transform translate-y-0 w-full"
                    className={`relative flex items-start group transition-opacity duration-200 opacity-100 transform translate-y-0 w-full ${
                      showDropdown === msg.commentID ? "z-40" : ""
                    }`}
                  >
                    {/* User Avatar */}
                    <div className="h-8 w-8 rounded-full overflow-hidden mr-2 flex-shrink-0">
                      <img
                        src={msg.user.avatar || ProfilePicTemp}
                        alt={msg.user.displayName}
                        className="h-full w-full object-cover"
                      />
                    </div>

                    <div className="flex-grow w-full min-w-0">
                      {/* Username & Timestamp */}
                      <div className="flex items-center flex-wrap">
                        <span className={`font-medium ${
                          msg.user.isCreator
                            ? "text-red-400"
                            : msg.user.isModerator
                            ? "text-green-400"
                            : "text-white"
                        }`}>
                          {msg.user.displayName}
                        </span>
                        {msg.user.isCreator && (
                          <i className="fas fa-check-circle text-blue-400 ml-1 text-xs" title="Verified"></i>
                        )}
                        {msg.user.isModerator && (
                          <i className="fas fa-shield text-green-400 ml-1 text-xs" title="Moderator"></i>
                        )}
                        <span className="ml-2 text-xs text-gray-500">{formatTime(msg.createdAt)}</span>
                      </div>

                      {/* Reply Section */}
                      {msg.replyTo && (
                        <div
                          className="mt-1 mb-1 pl-2 border-l-2 border-red-600 text-xs text-white/60 w-full break-words overflow-hidden"
                          onClick={() => {
                            if (msg.replyTo) {
                              const originalMsg = findMessageById(msg.replyTo.id);
                              if (originalMsg) {
                                const element = document.getElementById(`msg-${msg.replyTo.id}`);
                                element?.scrollIntoView({ behavior: "smooth", block: "center" });
                                element?.classList.add("bg-red-900/20");
                                setTimeout(() => element?.classList.remove("bg-red-900/20"), 2000);
                              }
                            }
                          }}
                        >
                          <div className="flex items-center flex-wrap min-w-0">
                            <span className="font-medium text-red-400 truncate">@{msg.replyTo.user}</span>
                            <span className="ml-2 truncate">{msg.replyTo.message}</span>
                          </div>
                        </div>
                      )}

                      {/* Message Content */}
                      {/* <p
                        id={`msg-${msg.commentID}`}
                        className="text-white/90 break-words whitespace-pre-wrap w-full overflow-hidden"
                      >
                        {highlightMentions(msg.message)}
                      </p> */}

                      <p
                        id={`msg-${msg.commentID}`}
                        className={`break-words whitespace-pre-wrap w-full overflow-hidden ${
                          msg.deleted ? "text-gray-500 italic" : "text-white/90"
                        }`}
                      >
                        {msg.deleted ? "This message has been deleted" : highlightMentions(msg.message)}
                      </p>

                    </div>

                    {!msg.deleted && (
                      <div
                      className={`flex items-center space-x-1 ${
                        showDropdown === msg.commentID
                          ? "opacity-100"
                          : "opacity-0 group-hover:opacity-100"
                      }`}
                    >
                      <button
                        onClick={() => handleReply(msg)}
                        className="text-white/50 hover:text-white transition-colors"
                      >
                        <i className="fas fa-reply text-xs"></i>
                      </button>

                      {/* Message Dropdown */}
                      <div className="relative z-20">
                        <button
                          onClick={() => toggleDropdown(msg.commentID)}
                          className="text-white/50 hover:text-white transition-colors"
                        >
                          <i className="fas fa-ellipsis-h text-xs"></i>
                        </button>

                        {showDropdown === msg.commentID && (
                          // <div onWheel={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-gray-800 border border-white/10 z-30">
                          <div onWheel={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-[#1A1A24] border border-white/10 z-50">
                            <div className="py-1">
                              <button onClick={() => setReportOpen(true)} className="flex items-center w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-white/10">
                                <i className="fas fa-flag text-xs"></i>
                                <span className="ml-2">Report Message</span>
                              </button>
                              {modStatus && (
                                <div> 
                                  <button onClick={() => deleteMSG(msg.commentID)} className="flex items-center w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-white/10">
                                    <i className="fas fa-trash text-xs"></i>
                                    <span className="ml-2">Delete Message</span>
                                  </button>
                                  <button onClick={() => handleModerationClick('timeout', msg.user.id)} className="flex items-center w-full text-left px-4 py-2 text-sm text-yellow-500 hover:bg-white/10">
                                    <i className="fas fa-clock text-xs"></i>
                                    <span className="ml-2">Timeout User</span>
                                  </button>
                                  <button onClick={() => handleModerationClick('ban', msg.user.id)} className="flex items-center w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-white/10">
                                    <i className="fas fa-hammer text-xs"></i>
                                    <span className="ml-2">Ban User</span>
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    )}
                  </div>
                ))}
                <div ref={chatEndRef} />
              </div>

              {!autoScroll && (
                <button
                  onClick={() => {
                    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' })
                    setAutoScroll(true)
                  }}
                  className="absolute right-2 bottom-2 bg-red-600 text-white text-xs px-2 py-1 rounded-md"
                >
                  Resume to messages
                </button>
              )}

              <div
                className={`border-t border-white/10 p-2 md:p-3 transition-all duration-300 ${
                  (isCollapsed && isMobile) ? "opacity-0 h-0 overflow-hidden p-0" : "opacity-100"
                }`}
              >
                {/* Reply indicator */}
                {replyingTo && (
                  <div className="mb-2 flex items-center justify-between bg-white/5 rounded-md p-2">
                    <div className="flex items-center text-sm">
                      <i className="fas fa-reply text-xs"></i>
                      <span className="ml-2 text-red-400 font-medium">@{replyingTo.user}:</span>
                      <span className="text-white/70 ml-1 truncate max-w-[200px]">{replyingTo.message}</span>
                    </div>
                    <button onClick={cancelReply} className="text-white/50 hover:text-white">
                      <i className="fas fa-xmark text-xs"></i>
                    </button>
                  </div>
                )}

                  {(() => {
                    if (!mainLoading) {
                      if (inputBanned && !timeout) {
                        return <div className="text-red-500 text-center text-sm mb-2">You are banned from sending messages.</div>
                      } else if (!inputBanned && timeout) {
                        return <div className="text-red-500 text-center text-sm mb-2">You are temporarily banned from sending messages.</div>
                      } else if (!inputBanned && !timeout) {
                        return <form onSubmit={handleSendMessage} className="flex items-center space-x-3">
                        <div className="relative">
                          <button
                            type="button"
                            onClick={toggleEmojiPicker}
                            className="text-white/70 hover:text-white hover:bg-white/10 h-9 w-9 rounded-full flex items-center justify-center transition-colors"
                          >
                            <i className="fas fa-face-smile text-lg"></i>
                          </button>
      
                          {showEmojiPicker && (
                            <div className="absolute bottom-full left-0 mb-2 p-2 bg-[#1A1A24] border border-white/10 rounded-lg shadow-lg z-10 w-64">
                              <div className="grid grid-cols-5 gap-2">
                                {popularEmojis.map((emojiChar, index) => (
                                  <button
                                    key={index}
                                    type="button"
                                    onClick={() => insertEmoji(emojiChar)}
                                    className="text-xl hover:bg-white/10 rounded p-1 transition-colors"
                                  >
                                    {emojiChar}
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
      
                        <div className="relative flex-grow">
                          <input
                            ref={inputRef}
                            type="text"
                            value={newMessage}
                            onChange={handleInputChange}
                            onKeyDown={handleInputKeyDown}
                            placeholder={replyingTo ? `Reply to ${replyingTo.user}...` : "Send a message..."}
                            className="w-full bg-white/5 border border-white/10 text-white rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent"
                          />
                          {showMentionList && mentionQuery && (
                            <div ref={mentionListRef} className="absolute bottom-full left-0 mb-1 bg-[#1A1A24] border border-white/10 rounded-md shadow-lg z-20 max-h-40 overflow-y-auto w-full">
                              {participants.filter(p => p.displayName.toLowerCase().includes(mentionQuery.toLowerCase())).slice(0,5).map(p => (
                                <button
                                  key={p.userID}
                                  type="button"
                                  onClick={() => selectMention(p)}
                                  className="flex items-center w-full text-left px-3 py-1 text-sm text-white focus:bg-white/10 hover:bg-white/10"
                                >
                                  <img
                                    src={p.profilePic || ProfilePicTemp}
                                    alt={p.displayName}
                                    className="h-5 w-5 rounded-full mr-2 object-cover"
                                  />
                                  <span>{p.displayName}</span>
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
      
                        <button
                          type="submit"
                          disabled={!newMessage.trim()}
                          className="bg-red-700 rounded-full h-9 w-9 flex items-center justify-center text-white disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <i className="fas fa-paper-plane text-mda"></i>
                        </button>
                      </form>
                      }
                    }
                  })()}

                  {/* {(() => {
                    if (inputBanned || timeout) {
                    }
                  })()} */}
              </div>
            </>
          ) : (
            <div className="flex-grow overflow-y-auto p-4 space-y-4 max-h-[calc(100vh-200px)] min-h-[400px]">
              <div className="flex items-center justify-between">
                {/* <h3 className="text-sm font-medium text-white">Participants (243)</h3> */}
                <h3 className="text-sm font-medium text-white">Participants ({participants.length})</h3>
                <input
                  type="text"
                  placeholder="Search participants..."
                  value={participantSearch}
                  onChange={(e) => setParticipantSearch(e.target.value)}
                  className="w-40 h-8 text-xs bg-white/5 border border-white/10 rounded-full px-3 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent"
                />
              </div>

              {filteredParticipants.map((user) => (
                <div key={user.userID} className="flex items-center justify-between py-2">
                  <div className="flex items-center space-x-2">
                    <div className="h-8 w-8 rounded-full overflow-hidden">
                      <img
                        src={user.profilePic || ProfilePicTemp}
                        alt={user.displayName}
                        className="h-full w-full object-cover"
                      />
                  </div>
                    <div>
                      <div className="text-sm font-medium text-white">{user.displayName}</div>
                    </div>

                    {modStatus && (
                      <div>
                        <button onClick={() => handleModerationClick('timeout', user.userID)} className="w-7 text-left px-2 py-2 text-sm text-yellow-500 hover:bg-white/10 rounded-md">
                          <i className="fas fa-clock text-xs"></i>
                        </button>
                        <button onClick={() => handleModerationClick('ban', user.userID)} className="w-7 text-left px-2 py-2 text-sm text-red-500 hover:bg-white/10 rounded-md">
                          <i className="fas fa-hammer text-xs"></i>
                        </button>
                      </div>
                    )}
                  </div>

                  {/* <button className="h-8 px-3 text-xs text-white/70 hover:text-white hover:bg-white/10 rounded-md transition-colors">
                    Profile
                  </button> */}

                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* <Transition appear show={this.state.reportModal} >
        <Dialog as="div" className="relative z-30 focus:outline-none" onClose={() => this.closeReportModal()} >
            <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 transform-[scale(95%)]"
                        enterTo="opacity-100 transform-[scale(100%)]"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 transform-[scale(100%)]"
                        leaveTo="opacity-0 transform-[scale(95%)]"
                    >
                        <DialogPanel className="w-full max-w-md rounded-xl bg-gray-800 p-6 backdrop-blur-2xl">
                            <DialogTitle as="h3" className="text-2xl font-bold text-white">
                                Report an issue
                            </DialogTitle>
                            <div className="mt-4">
                                <form className="grid grid-cols-1 gap-4" onSubmit={(e) => this.submitReport(e)}>
                                    <div className="flex flex-col">
                                        <label className="mb-2 text-white font-bold text-md">Title</label>
                                        <input onChange={(e) => this.reportForm(e.target.value, 'title')} required className="rounded-md p-2 bg-gray-900 text-white shadow-md" placeholder="Title ..." />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="mb-2 text-white font-bold text-md">Issue Category</label>
                                        <select onChange={(e) => this.reportForm(e.target.value, 'category')} required className="rounded-md p-2 bg-gray-900 text-white shadow-md">
                                            <option value=""></option>
                                            <option value="bug">Bug</option>
                                            <option value="copyright">Copyright Infringement</option>
                                            <option value="tos">Breach TOS</option>
                                            <option value="support">Support</option>
                                            <option value="content">Inappropriate Content</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="mb-2 text-white font-bold text-md">Description</label>
                                        <textarea onChange={(e) => this.reportForm(e.target.value, 'desc')} required className="rounded-md p-2 bg-gray-900 text-white shadow-md" rows={4} placeholder="Issue Description, where it happened? (post title/page name), previous steps leading up till the issue ..."></textarea>
                                    </div>
                                    <div className="flex grid grid-cols-2 gap-4">
                                        <span onClick={() => this.closeReportModal()} className="bg-gray-900 text-white rounded-md p-2 mt-2 text-center hover:cursor-pointer shadow-md">Cancel</span>
                                        <button ref={this.reportSubmit} disabled type="submit" className="bg-red-600 disabled:bg-red-400 text-white rounded-md p-2 mt-2 shadow-md">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
      </Transition> */}

      {reportModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={closeReport} />

          {/* Modal Content */}
          <div className="relative bg-gray-900 rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-white">
                  Report User
                </h3>
                <p className="text-sm text-white mt-1">
                  Please provide a reason for the report to help us understand the issue better.
                </p>
              </div>
              <button onClick={closeReport} className="text-gray-400 hover:text-gray-600 focus:outline-none">
                <X className="h-5 w-5" />
              </button>
            </div>

            <div className="mb-6">
              <label htmlFor="reason" className="block text-sm font-medium text-white mb-2">
                Reason
              </label>
              <textarea
                id="reason"
                rows={3}
                placeholder="Enter reason for report"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full px-3 py-2 border border-gray-700 focus:ring-2 focus:ring-red-700 bg-gray-800 rounded-md shadow-sm focus:outline-none resize-none"
              />
            </div>

            <div className="flex gap-3 justify-end">
              <button
                onClick={handleCancel}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Cancel
              </button>
              <button
                onClick={confirmReport}
                // disabled={!duration}
                className={`px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${
                  moderationAction === "ban"
                    ? "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500"
                    : "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500"
                }`}
              >
                Report User
              </button>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={handleCancel} />

          {/* Modal Content */}
          <div className="relative bg-gray-900 rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-white">
                  {moderationAction === "ban" ? "Ban User" : "Timeout User"}
                </h3>
                <p className="text-sm text-white mt-1">
                  {moderationAction === "ban"
                    ? "Select the duration for the ban and provide a reason."
                    : "Select the timeout duration and provide a reason."}
                </p>
              </div>
              <button onClick={handleCancel} className="text-gray-400 hover:text-gray-600 focus:outline-none">
                <X className="h-5 w-5" />
              </button>
            </div>

            {/* Duration Selection */}
            {moderationAction !== "ban" && (
              <div className="mb-6">
                <label className="block text-sm font-medium text-white mb-3">Duration</label>
                <div className="grid grid-cols-3 gap-2">
                  {getDurationOptions().map((option) => (
                    <button
                      key={option.value}
                      onClick={() => setDuration(option.value)}
                      className={`px-3 py-2 text-sm font-medium rounded-md border transition-colors ${
                        duration === option.value
                          ? "bg-red-600 text-white border-red-600"
                          : "bg-gray-800 text-white border-gray-700 hover:bg-red-600"
                      }`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
                {duration && (
                  <div className="mt-3">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      Selected: {getDurationOptions().find((opt) => opt.value === duration)?.label}
                    </span>
                  </div>
                )}
              </div>
            )}

            {/* Reason */}
            <div className="mb-6">
              <label htmlFor="reason" className="block text-sm font-medium text-white mb-2">
                Reason (Optional)
              </label>
              <textarea
                id="reason"
                rows={3}
                placeholder="Enter reason for moderation action..."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full px-3 py-2 border border-gray-700 focus:ring-2 focus:ring-red-700 bg-gray-800 rounded-md shadow-sm focus:outline-none resize-none"
              />
            </div>

            {/* Footer */}
            <div className="flex gap-3 justify-end">
              <button
                onClick={handleCancel}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Cancel
              </button>

              {moderationAction === "ban" ? (
                <button
                  onClick={handleConfirm}
                  className="px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-red-600 text-white hover:bg-red-700 focus:ring-red-500"
                >
                  Ban User
                </button>
              ) : (
                <button
                  onClick={handleConfirm}
                  disabled={!duration}
                  className="px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed bg-red-600 text-white hover:bg-red-700 focus:ring-red-500"
                >
                  Timeout User
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

